import VuexHelper from '../../helpers/vuex-helper'

const Vuex = new VuexHelper('Exam')

export const State = Vuex.State
export const Getter = Vuex.Getter
export const Action = Vuex.Action
export const Mutation = Vuex.Mutation
